/*
    OOS variants grey overlay
    implemented: layout\theme.liquid
    require: sections\main-product.liquid (script ld+json)
*/

window.addEventListener('DOMContentLoaded', (event) => {

    function firstLoad(){
        
        setTimeout(()=>{
            const targetNode = document.querySelector('.selected-color__value');
            const data = document.querySelector("script#product-data").innerHTML
            const targetSizes = document.querySelectorAll('.variant-size__label');
            const tSizes = [...targetSizes]       
        
            if(!targetNode || !data){
            console.log("Can't find selected variant color or variant data")
            return;
            }                          
                                    
            const { color } = targetNode.dataset;                           
            const parsedData = JSON.parse(data);
            const { variants } = parsedData;

            console.log("node", color)
            console.log("variants", variants)

            const transform = variants.reduce((acc, next) =>{
            const [name, size] = next.title.split(" / ")
            return [
            ...acc,
                {[name]: {[size]: next.stock}}
            ]
        },[]);
                                    
        console.log({transform})
        const dataSizes = transform.filter((item) => item[color]).sort()
        
        if(dataSizes.length <= 0 ) {
            throw new Error(`No sizes found for variant ${color}`)
        }
        
        console.log("datasizes", dataSizes);
        
        tSizes.forEach((size, i) => {
            const {variantSize} = size.dataset
            //console.log("variantsize", variantSize)
            const outOfStockSizes = getOutStock(variantSize);

            if(outOfStockSizes.length <= 0){
            return;
            }

            // DOM UPDATE
            outOfStockSizes.forEach(invalid => {
            console.log("out stock", {size, available: invalid[color][variantSize]});
            if(invalid[color][variantSize] === false){
                size.classList.toggle('out-of-stock__size');
            }
            })
            
        });

        function getOutStock(size){
            return dataSizes.filter(el => el[color][size] === false);
        } 
        
         console.log('first render')  

        }, 500) 
        
    } 

    firstLoad()


    // variant onchnage
    // mutataion observer .selected-color__value to get the current color
    document.addEventListener('click', ()=>{
        setTimeout(()=>{
            const targetNode = document.querySelector(".selected-color__value");

    
            const data = document.querySelector("script#product-data").innerHTML
            const targetSizes = document.querySelectorAll('.variant-size__label');
            const tSizes = [...targetSizes]       
        
            if(!targetNode || !data){
            console.log("Can't find selected variant color or variant data")
            return;
            }                          
                                    
            const { color } = targetNode.dataset;                           
            const parsedData = JSON.parse(data);
            const { variants } = parsedData;

            console.log({color})
            console.log("variants", variants)

            const transform = variants.reduce((acc, next) =>{
            const [name, size] = next.title.split(" / ")
            return [
            ...acc,
                {[name]: {[size]: next.stock}}
            ]
        },[]);
                                    
        console.log({transform})
        const dataSizes = transform.filter((item) => item[color]).sort()
        
        if(dataSizes.length <= 0 ) {
            throw new Error(`No sizes found for variant ${color}`)
        }
        
        console.log("datasizes", dataSizes);
        
        tSizes.forEach((size, i) => {
            const {variantSize} = size.dataset
            //console.log("variantsize", variantSize)
            const outOfStockSizes = getOutStock(variantSize);

            if(outOfStockSizes.length <= 0){
            return;
            }

            // DOM UPDATE
            outOfStockSizes.forEach(invalid => {
            console.log("out stock", {size, available: invalid[color][variantSize]});
            if(invalid[color][variantSize] === false){
                size.classList.add('out-of-stock__size');
            }
            })
            
        });

        function getOutStock(size){
            return dataSizes.filter(el => el[color][size] === false);
        } 
        
        },1000)
    })
 
   



});
